import { SECTION_MENU, SECTION_MENU_Remove } from '../actions/types'

const initialState = []

const sectionMenuDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SECTION_MENU:
      return action.payload
    case SECTION_MENU_Remove:
      return action.payload
    default:
      return state
  }
}

export default sectionMenuDataReducer
